import closeSvg from "~/foundation/Icons/close";
import { isRtl } from "~/foundation/Helpers/isRtl";

export const closeMarkup = `<button type="button" class="membership-close">${closeSvg}<span>${
	isRtl ? "أغلق" : "close"
}</span></button>`;
